import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-commission',
	templateUrl: './commission.component.html',
	styleUrls: ['./commission.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CommissionComponent {}
